import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { IconsWithBulletListsStyle } from '../../../styles/components/common/blocks';

export interface IIconsWithBulletListItem {
  title: string;
  iconPath: string;
  list: string;
}

export interface IIconsWithBulletListsProps {
  items: IIconsWithBulletListItem[];
}

export const IconsWithBulletLists = (props: IIconsWithBulletListsProps) => {
  return (
    <div className={IconsWithBulletListsStyle['icons-with-bullet-lists']}>
      {props.items.map((item, index) => (
        <div
          key={index}
          className={IconsWithBulletListsStyle['icons-with-bullet-lists-item']}>
          <Image
            quality={90}
            src={item.iconPath}
            alt={item.title}
            width={80}
            height={80}
          />
          <div>
            <h3>{item.title}</h3>
            <ReactMarkdown>{item.list}</ReactMarkdown>
          </div>
        </div>
      ))}
    </div>
  );
};

export default IconsWithBulletLists;
